// Inline SVG placeholder utility — produces a data:URI image with a label.
// Replace any of the URLs in data/site.js with a real CDN URL once photos are ready.
export const placeholderImage = (label, opts = {}) => {
  const { bg = "#1a1a1a", fg = "#C27A3E", subtitle = "Replace with real photo" } = opts;
  const safeLabel = String(label).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const safeSub = String(subtitle).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const svg = `
<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 1000' preserveAspectRatio='xMidYMid slice'>
  <defs>
    <pattern id='p' width='80' height='80' patternUnits='userSpaceOnUse' patternTransform='rotate(45)'>
      <rect width='40' height='80' fill='${bg}'/>
      <rect x='40' width='40' height='80' fill='#222'/>
    </pattern>
  </defs>
  <rect width='1600' height='1000' fill='url(#p)' opacity='0.9'/>
  <rect x='40' y='40' width='1520' height='920' fill='none' stroke='${fg}' stroke-width='4' stroke-dasharray='18 14'/>
  <g font-family='Manrope, Arial, sans-serif' text-anchor='middle' fill='white'>
    <text x='800' y='470' font-size='80' font-weight='600' letter-spacing='-2'>${safeLabel}</text>
    <text x='800' y='540' font-size='28' fill='${fg}' letter-spacing='6' font-weight='600'>${safeSub.toUpperCase()}</text>
  </g>
</svg>`.trim();
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};
